import app from '../app.first';
import $ from 'jquery';

app.HomePage = class extends app.Component {
    constructor($this) {
        super($this);
        $(() => this.onDocumentReady($this));
        //this.$form = $this.find('.contact-form')
	}

	onDocumentReady($this) {

        if (/join/.test(location.search)) {
            $('#auth_modal').foundation('open');
            $('#register_candidate_main').show();
            $('#register_candidate_email').hide();
            $('#register_recruiter').hide();
            $('#login').hide();
            $('#forgot_password').hide();
        }

        $(window).on('resize', () => {
            this.generateSlideshow($this);

            let wrappers = $('.steps-wrapper .steps .step-wrapper');
            let wrapper1 = $(wrappers[0]);
            let wrapper2 = $(wrappers[1]);
            let right1 = (wrapper1.offset().left + wrapper1.width());
            let left2 = wrapper2.offset().left;
            let gap = left2 - right1;
            let circle1 = wrapper1.find('.step-circle .circle-outer');
            let dots = $('.steps-wrapper .steps .step-wrapper .step-dots');
            let innerOffset = ((wrapper1.width() - circle1.outerWidth()) * 0.4);
            dots.css('left', wrapper1.width() + (gap * 0.5));
            dots.width((gap + (innerOffset * 2)) / 3);

        });

        $(window).trigger('resize');

        /*if (this.$form.data('trustedClient')) {
            return true;
        }

        let allowSubmit = false;
        this.$form.on('submit', function() {
            return allowSubmit;
        });

        this.$form.on('formvalid.zf.abide', (e) => {
            grecaptcha.ready(() => {
                grecaptcha.execute('6Ldrh4gUAAAAAFo9_t2rmN59KWOEBQ14S5-lyOin', {action: 'action_name'})
                .then((token) => {
                    $.ajax({
                        url: "/captcha/verify",
                        data: {
                            response: token
                        },
                        // dataType: 'json',
                        method: 'POST',
                        beforeSend: (xhr) => {
                            xhr.setRequestHeader('X-CSRF-Token', $('[name="_csrfToken"]').val());
                        },
                        success: ((response) => {
                            console.log(response);
                            if (response.success && response.score > response.tolerance) {
                                this.$form.append("<input type='hidden' name='token' value='"+token+"' />");
                                allowSubmit = true;
                                this.$form.trigger('submit');
                            }
                        })
                    });
                });
            });
        });*/
    }

    generateSlideshow($this) {
        $this.find('.steps-wrapper .steps').not('.slick-initialized').slick({
            infinite: false,
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 721,
                    settings: 'unslick',
                }
            ]
        });

        $this.find('.testimonials-wrapper .testimonials').not('.slick-initialized').slick({
            infinite: false,
            dots: false,
            slidesToShow: 2,
            slidesToScroll: 2,
            prevArrow: '<button type="button" class="slick-prev"><i class="fa fa-chevron-left"></i></button>',
            nextArrow: '<button type="button" class="slick-next"><i class="fa fa-chevron-right"></i></button>',
            mobileFirst: true,
            responsive: [
                {
                    breakpoint: 1025,
                    settings: 'unslick',
                }
            ]
        });
        
    }
}